import axios from "axios";
import { appConstants } from "../_constants/app.constants";

function toUpperId(id) {
  return id ? String(id).toUpperCase() : "";
}

export async function resolveTournamentIdForViewer(routeTournamentId) {
  if (routeTournamentId) return routeTournamentId;
  return null;
}

export function dedupeTeamImages(images) {
  const byId = new Map();
  (Array.isArray(images) ? images : []).forEach((img) => {
    const id = img?.id;
    const imageData = img?.imageData;
    if (!id || !imageData) return;
    byId.set(toUpperId(id), {
      id,
      imageData,
      name: img?.name ?? "",
    });
  });
  return Array.from(byId.values());
}

export function readCachedTournamentImages(tournamentId) {
  if (!tournamentId) return [];
  try {
    const raw = localStorage.getItem(`${tournamentId}-images`);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return dedupeTeamImages(parsed);
  } catch {
    return [];
  }
}

export function buildImageMap(images) {
  const map = new Map();
  dedupeTeamImages(images).forEach((img) => {
    map.set(toUpperId(img.id), img.imageData);
  });
  return map;
}

export function patchTeamShield(team, imageMap) {
  if (!team || !team.id) return team;
  const mapped = imageMap.get(toUpperId(team.id));
  if (!mapped) return team;
  if (team.shield === mapped) return team;
  return { ...team, shield: mapped };
}

function pushTeamImage(images, team) {
  if (!team || !team.id || !team.shield) return;
  images.push({
    id: team.id,
    imageData: team.shield,
    name: team.name ?? "",
  });
}

export function collectImagesFromGroups(groups) {
  const images = [];
  (Array.isArray(groups) ? groups : []).forEach((group) => {
    (group?.tournamentGroupTeams ?? []).forEach((groupTeam) => {
      pushTeamImage(images, groupTeam?.team);
    });
  });
  return dedupeTeamImages(images);
}

export function collectImagesFromMatches(matches) {
  const images = [];
  (Array.isArray(matches) ? matches : []).forEach((match) => {
    pushTeamImage(images, match?.localTeam);
    pushTeamImage(images, match?.foreignTeam);
    pushTeamImage(images, match?.winnerTeam);
  });
  return dedupeTeamImages(images);
}

export const collectImagesFromBracketFlat = collectImagesFromMatches;
